import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", null, "카테고리 이름", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = { class: "form-group mb-5" }
const _hoisted_10 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_11 = /*#__PURE__*/_createVNode("label", null, "노출 여부", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
        class: { loading: _ctx.loading }
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.category.name = $event)),
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.category.name]
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("label", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createVNode("input", {
                  type: "checkbox",
                  class: "c-switch-input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.category.status = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.category.status]
                ]),
                _hoisted_12
              ])
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "저장",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 34)
    ])
  ]))
}